import { create } from 'zustand';

/**
 * name attribute corresponds to an 'step_name' that fires when a step loads,
 * this does not include all 'step_name's that fire
 */
type StepData = {
	name: string;
	number: number;
};

const AVAILABLE_STEPS: StepData[] = [
	{
		name: 'start_about_you',
		number: 1,
	},
	{
		name: 'patient_information',
		number: 2,
	},
	{
		name: 'location_date_time_page_load',
		number: 3,
	},
	{
		name: 'complete',
		number: 4,
	},
];
// ^ NOTE: these do not need to be in state, make a getter that can just fetch these based on the step number

type StepManagerState = {
	currentStep: number;
	currentStepName: () => string | null;
};

type StepManagerActions = {
	incrementStep: () => void;
	decrementStep: () => void;
	setSpecifiedStep: (step: number) => void;
};

const useStepManagerStore = create<StepManagerState & StepManagerActions>((set, get) => ({
	currentStep: 1,
	currentStepName: () => {
		const step = AVAILABLE_STEPS.find((step) => step.number === get().currentStep);
		return step ? step.name : null;
	},
	incrementStep: () => {
		set({ currentStep: get().currentStep + 1 });
	},
	decrementStep: () => {
		if (get().currentStep < 2) {
			console.error('Cannot decrement step below 1');
			return;
		}

		set({ currentStep: get().currentStep - 1 });
	},
	setSpecifiedStep: (step: number) => {
		if (step < 1 || step > AVAILABLE_STEPS.length) {
			console.error('setSpecifiedStep(): Invalid step number');
			return;
		}

		set({ currentStep: step });
	},
}));

export default useStepManagerStore;
